import { useLoaderData } from "react-router-dom";
import * as recipeService from "../../services/RecipeService";
import RecipeList from "../../components/recipe-list/RecipeList";
import {useContext, useEffect, useState} from "react";
import DisplayContext from "../../context/DisplayContext";
import {getAllRecipes} from "../../services/RecipeService";

const HomePage = () => {
    const [page, setPage] = useState(0)
    const [recipesPage, setRecipesPage] = useState(useLoaderData())
    const { toggleHeaderSearch } = useContext(DisplayContext)

    useEffect(() => {
        document.title = "Cocktails"
    }, [])
    useEffect(() => () => {
        toggleHeaderSearch(true)
    })
    useEffect( () => {
        (async () => {
            setRecipesPage(await getAllRecipes(page))
        })()
    }, [page])

    return (
        <div>
            <div className='gutters'>
                <RecipeList recipes={recipesPage} setPage={ setPage }/>
            </div>
        </div>
    )
}

const homePageLoader = () => {
    return recipeService.getAllRecipes()
}

export default HomePage
export { homePageLoader }
